if (typeof window !== "undefined") {
  window._env_ = window._env_ || {};
}

export {};
